import React, { useState } from "react";
import PropTypes from "prop-types";
import { notification } from "../../../utils/Notifications";
import { deliverGuide } from "../../../api/guidesApi";
import useLogout from "../../../hooks/auth/authHook.js";
import {
  Button,
  Container,
  Dialog,
  Typography,
  CircularProgress,
} from "@mui/material";
import styles from "./deliveryDeliverGuideDialogStyles.js";

DeliveryDeliverGuideDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function DeliveryDeliverGuideDialog({
  onClose,
  open,
  guide,
  fetchGuides,
}) {
  const [logout] = useLogout();

  const [isLoading, setIsLoading] = useState(false);

  const handleDialogClose = () => {
    onClose();
  };

  const handleAssingUserLotAdminClick = () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    deliverGuide(guide?.id, guide?.id_batch)
      .then((response) => {
        if (response.data.status_Code === 200) {
          fetchGuides()
          setIsLoading(false);
          notification({
            text: "Guía entregada",
            type: "success",
          });
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          setIsLoading(false);
          onClose();
          logout();
        } else {
          notification({
            text: "Error al entregar la guía",
            type: "error",
          });
          setIsLoading(false);
        }
      })
      .catch(() => {
        notification({
          text: "Error de conexión, revisa tu conexión a internet",
          type: "error",
        });
        setIsLoading(false);
          onClose();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{ style: styles.dialog }}
    >
      <Container style={styles.mainContainer}>
        <Typography
          component="div"
          variant="h5"
          style={styles.title}
        >
          Entregar paquete
        </Typography>
        <Typography
          component="div"
          variant="body1"
          style={styles.subtitle}
        >
          El número de guía es: {guide?.tracking_code}
        </Typography>

        <Container style={styles.buttonsContainer}>
          <Button
            variant="standard"
            color="primary"
            onClick={() => {
              onClose();
            }}
            style={styles.cancelButton}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            disabled={guide ? false : true}
            onClick={() => {
              handleAssingUserLotAdminClick();
            }}
            sx={guide ? styles.activeButton : styles.inactiveButton}
          >
            {isLoading ? (
              <CircularProgress size={24} style={styles.circularProgress} />
            ) : (
              "Entregar"
            )}
          </Button>
        </Container>
      </Container>
    </Dialog>
  );
}
